import {buildHeader} from './header';
import {detailedInformation} from './detailed-information';
import {buildSummedDetailedInformation} from './sumed-detailed-information';
import {reimbursementTypes, reimbursableOpEx} from './annex';

let cloneDeep = require('lodash.clonedeep');

export function buildReimbTab(tab) {
    return cloneDeep({
        name: tab === 'current-reimbursement-tab' ? 'Current Reimbursements' : 'ProForma Reimbursements',
        tables: {
            'header': buildHeader(tab),
            'detailed-information': detailedInformation,
            'sumed-detailed-information': buildSummedDetailedInformation(tab),
            'reimbursement-types': reimbursementTypes,
            'reimbursable-op-ex': reimbursableOpEx
        }
    });
}